"use strict";

function execute() {}  // ASSERT_TRACKING_EXECUTE_LINE
// In AssertAug.js, we put a BP on this line. We use this BP to get the stack trace and locals of the matcher
// we hooked. We can do this since `this.execute` is placed in the hooked function.
// DO NOT EDIT THIS FILE WITHOUT CHECKING THAT THE TRANSPILED FILE LINE IS THE SAME AS THE PRE-TRANSPILED LINE!!!

module.exports = execute;
